export const getProductionOutsourceList = state => {
    return state.list
}

export const getProductionOutsourceDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/productionOutsource/getters.js